import { URL_SERVER } from "../constans/url";
import canvasState from "../store/canvasState";

export const getImg = (id: string) => {
    fetch(`${URL_SERVER}/image?id=${id}`)
        .then(res => res.json())
        .then(data => {
            const ctx = canvasState.canvas?.getContext('2d');
            const img = new Image();
            img.src = data;
            img.onload = () => {
                ctx?.clearRect(0, 0, canvasState.canvas?.width!, canvasState.canvas?.height!);
                ctx?.drawImage(img, 0, 0, canvasState.canvas?.width!, canvasState.canvas?.height!);
            }
    })
}

export const postImg = (id: string) => {
    fetch(`${URL_SERVER}/image?id=${id}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json;charset=utf-8'
        },
        body: JSON.stringify({
            img: canvasState.canvas?.toDataURL()
        })
    })
        .then(res => res.json())
        .then(res => console.log(res))
}